import HttpMethodType from 'HttpMethodType';
import SubSystemType from 'SubSystemType';
import BaseServiceRequest from 'BaseServiceRequest';

class GetDefaultKpiItems extends BaseServiceRequest {
    constructor() {
        super();
        super.addRequestUri("getdefaultkpidata.pb");
    }

    getMethod() {
        return HttpMethodType.GET;
    }

    getSubSystem() {
        return SubSystemType.GRAPH;
    }

    getMessageName() {
        return "KpiDefaultItemDataResponse";
    }
}

export default GetDefaultKpiItems;
